import React from "react";
import { Link } from "react-router-dom";
// Get styles
import styles from "./../styles/azkar.module.css";
// Get Images
import VectorRight from "./../Images/Desktop-2/Vector-right.png";
import VectorLeft from "./../Images/Desktop-2/Vector-left.png";
import VectorDown from "./../Images/Desktop-2/Vector-down.png";
import Morning from "./All-Azkare-mob/Morning";
import Evening from "./All-Azkare-mob/Evening";
import GettingUp from "./All-Azkare-mob/GettingUp";
import { motion } from "framer-motion";

function Allazkar() {
  if (window.innerWidth >= 992) {
    return (
      <motion.div className="bgAzkar  mt-5">
        <motion.div
          initial={{ y: "-100vw" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="container  position-relative  h-100 flex flex-wrap justify-between "
        >
          {/* Evening */}
          <motion.div
            initial={{ y: "-100vw" }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className={`position-absolute top-50 start-0 translate-middle-y ${styles.msaa}`}
          >
            <div className="relative sbah">
              <Link
                to={`/evening`}
                className={`z-50 ${styles.sbah} text-decoration-none hover:text-gray-300`}
              >
                <img
                  className="h-100 z-10 w-100 absolute"
                  src={VectorLeft}
                  alt=""
                />
                <div className="p-4 z-20">
                  <h1 className="p-5 z-50">اذكار المساء</h1>
                </div>
              </Link>
            </div>
          </motion.div>
          {/* Morning */}
          <motion.div
            initial={{ y: "-100vw" }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className={`position-absolute top-50 end-0 translate-middle-y ${styles.sbah}`}
          >
            <div className="relative sbah">
              <Link
                to={`/morning`}
                className={`z-50 ${styles.sbah} text-decoration-none hover:text-gray-300`}
              >
                <img
                  className="h-100 z-10 w-100 absolute"
                  src={VectorRight}
                  alt=""
                />
                <div className="p-4 z-20">
                  <h1 className="p-5 z-50">اذكار الصباح</h1>
                </div>
              </Link>
            </div>
          </motion.div>
        </motion.div>
        {/* gettingUp */}
        <motion.div
          initial={{ y: "-100vw" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className={` position-absolute bottom-0 start-50 translate-middle-x ${styles.astikaz}`}
        >
          <div className="relative sbah ">
            <Link
              to={`/gettingUp`}
              className={`z-50 ${styles.sbah} text-decoration-none hover:text-gray-300`}
            >
              <img
                className="h-100 z-10 w-100 absolute"
                src={VectorDown}
                alt=""
              />
              <div className="p-4 z-20">
                <h1 className="p-5 z-50">اذكار الاستيقاظ</h1>
              </div>
            </Link>
          </div>
        </motion.div>
      </motion.div>
    );
  } else {
    return (
      <div className="bgAzkar  me-2">
        <motion.div
          initial={{ y: "-100vw" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="flex justify-center align-items-center mt-4 row container h-100"
        >
          <div className={`col-10`}>
            {/* Morning */}
            <Morning />
          </div>
          <div className={`col-10`}>
            {/* Evening */}
            <Evening />
          </div>
          <div className={`col-10`}>
            {/* gettingUp */}
            <GettingUp />
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Allazkar;
